import type { Dict } from "../lib/i18n";

// Keys are prefixed "wallet." — keep zh / en / nl in step.
export default {
  zh: {
    "wallet.scan.needNumber": "请填写卡号，或者再拍一次条码",
    "wallet.import.open": "从其他卡包导入",
    "wallet.import.title": "从其他卡包导入",
    "wallet.import.intro": "卡已经放在苹果钱包、Google 钱包、Klarna（Stocard）或别的卡包里？选一种方式，一次全部搬过来。都在手机上读取，保存前你可以先检查。",
    "wallet.import.apple": "苹果钱包（Apple Wallet）",
    "wallet.import.apple1": "在“钱包”里打开一张卡，点右上角的“…”。",
    "wallet.import.apple2": "选“共享卡券”，再选“存储到‘文件’”（没有这一项时，用“邮件”发给自己，再在邮件里把附件存到“文件”）。每张卡做一次。",
    "wallet.import.apple3": "回到这里点下面的按钮，一次选好所有卡（.pkpass 文件）。有的卡不能共享，就用下面的“截图导入”。",
    "wallet.import.pickPass": "选择苹果钱包的卡（.pkpass）",
    "wallet.import.shots": "截图导入（Google 钱包、Klarna/Stocard、任何卡包）",
    "wallet.import.shots1": "在原来的卡包里一张一张打开卡，让条形码完整、清楚地显示出来。",
    "wallet.import.shots2": "每张卡截一次屏（最好能看到商店名字）。",
    "wallet.import.shots3": "回到这里点下面的按钮，一次选好所有截图。",
    "wallet.import.pickShots": "选择截图（可以多选）",
    "wallet.import.file": "导出的文件（Catima 等）",
    "wallet.import.fileHint": "有些卡包可以“导出/备份”成 .csv 或 .zip 文件（例如安卓上的 Catima）。导出时不要设密码，然后在这里选择这个文件。",
    "wallet.import.pickFile": "选择导出文件（.csv / .zip）",
    "wallet.import.reading": "正在读取 {done} / {total}…",
    "wallet.import.none": "没有读到卡。截图请让条形码完整清楚；文件请确认没有设密码。",
    "wallet.import.check": "检查一下：名字可以改，不要的取消勾选。灰色的是卡包里已经有的。",
    "wallet.import.failed": "有 {n} 个文件或截图没读出来（条形码不完整、太模糊，或不是卡）。",
    "wallet.import.namePh": "商店名称",
    "wallet.import.have": "已经有了",
    "wallet.import.needName": "还有 {n} 张卡没写商店名称。",
    "wallet.import.more": "换一种方式重新导入",
    "wallet.import.save": "保存 {n} 张卡",
    "wallet.import.done": "已导入 {n} 张卡。",
    "wallet.import.skipped": "{n} 张已经在卡包里，跳过了。",
    "wallet.scan.maybe": "看颜色，可能是这几家，点一下就好：",
    "wallet.scan.pickFile": "从相册或文件选择",
    "wallet.scan.photoCard": "拍一张卡片照片",
    "wallet.scan.processing": "正在识别卡片：条形码、卡号、商店…",
    "wallet.scan.noCodeOnPhoto": "这张照片里没找到条形码。再拍一下卡片有条形码的那一面（通常是背面）。",
    "wallet.scan.photoBack": "拍有条形码的那一面",
    "wallet.scan.yourCard": "你的卡",
    "wallet.scan.pickShopShort": "选一下商店",
    "wallet.scan.needShop": "在下面点一下这张卡的商店（或输入名字），就可以保存了。",
    "wallet.scan.title": "扫描卡片",
    "wallet.scan.confirmTitle": "确认这张卡",
    "wallet.scan.hint": "拍一张卡片照片，或者把卡上的条形码放进框里，都会自动识别",
    "wallet.scan.noCamera": "无法打开摄像头。可以拍一张卡片条形码的照片，或者手动输入卡号。",
    "wallet.scan.photo": "拍条形码照片",
    "wallet.scan.manual": "没有条形码，输入卡号",
    "wallet.scan.noCode": "照片里没找到条形码。请把条形码拍清楚、拍正一点再试。",
    "wallet.scan.again": "重新扫描",
    "wallet.scan.save": "放进卡包",
    "wallet.scan.fullForm": "手动填写全部信息（照片、国家、备注…）",
    "wallet.scan.reading": "正在识别卡上的商店名字…",
    "wallet.scan.recognised": "识别出商店：{name}",
    "wallet.scan.number": "卡号",
    "wallet.scan.shop": "是哪家商店的卡？",
    "wallet.scan.shopSearch": "搜索商店，或直接输入名字",
    "wallet.scan.otherShop": "没有找到，就叫“{name}”",
    "wallet.scan.addCode": "扫描这张卡的条形码",
    "wallet.action.notes": "备注",
    "wallet.action.photos": "卡片图片",
    "wallet.action.share": "分享卡片",
    "wallet.brandPick": "选一个商店，自动配上 Logo 和颜色",
    "wallet.form.colorAuto": "自动",
    "wallet.form.color": "卡片颜色",
    "wallet.frequent": "常用 · 按你的使用自动排在前面",
    "wallet.groupsHint": "分组只是帮你归类。没有卡片的分组不会显示在卡包页面上。",
    "wallet.manageGroups": "管理分组",
    "wallet.all": "全部",
    "wallet.groups": "分组",
    "wallet.add": "添加",
    "wallet.title": "会员卡包",
    "wallet.hero": "会员卡都在这里",
    "wallet.heroSub": "结账时打开卡片，直接出示条形码给收银员扫。",
    "wallet.search": "查找卡片",
    "wallet.addCard": "添加卡片",
    "wallet.newWallet": "新建卡包",
    "wallet.results": "搜索结果 · {n}",
    "wallet.noMatches": "没有找到匹配的卡片。",
    "wallet.empty.title": "还没有会员卡",
    "wallet.empty.body": "给卡片上的条形码拍张照，我们会在你的手机上直接识别出条码，结账时就能出示，不用再带实体卡。",
    "wallet.noWallet": "未分类",
    "wallet.unnamed": "卡包",
    "wallet.preset.everyday": "超市日常",
    "wallet.preset.dining": "餐饮咖啡",
    "wallet.preset.shopping": "购物礼品",
    "wallet.preset.travel": "出行休闲",
    "wallet.addHere": "添加到这里",
    "wallet.cardAdded": "卡片已添加",

    "wallet.folder.edit": "编辑卡包：{name}",
    "wallet.folder.empty": "这个卡包是空的。",
    "wallet.folder.newTitle": "新建卡包",
    "wallet.folder.renameTitle": "卡包名称",
    "wallet.folder.name": "名称",
    "wallet.folder.namePlaceholder": "例如：药店",
    "wallet.folder.create": "创建",
    "wallet.folder.created": "卡包已创建",
    "wallet.folder.delete": "删除卡包",
    "wallet.folder.deleted": "卡包已删除",
    "wallet.folder.deleteHint": "只能删除空卡包。请先把里面的卡片移到别的卡包。",

    "wallet.trash.title": "卡片回收站 · {n}",
    "wallet.trash.sub": "恢复误删的卡片，或永久删除",
    "wallet.trash.heading": "卡片回收站",
    "wallet.trash.empty": "回收站是空的。",
    "wallet.trash.when": "{date} 移入回收站",
    "wallet.trash.foreverBody": "永久删除“{name}”及其照片？此操作无法撤销。",

    "wallet.showAtCheckout": "结账时出示",
    "wallet.brightness": "把屏幕亮度调高，扫码更容易。",
    "wallet.noCode": "这张卡没有保存条形码。可以出示卡号或卡片照片。",
    "wallet.copyNumber": "复制卡号",
    "wallet.copied": "卡号已复制",
    "wallet.copyFailed": "无法复制，请手动选中卡号。",
    "wallet.codeDetails": "条码内容",
    "wallet.viewPhoto": "查看大图：{side}",
    "wallet.barcodeAlt": "条形码：{value}",
    "wallet.barcodeFailed": "无法生成条形码。请出示卡号或照片。",
    "wallet.editMove": "编辑 / 移动",
    "wallet.moveToTrash": "移到回收站",

    "wallet.form.addTitle": "添加卡片",
    "wallet.form.editTitle": "编辑卡片",
    "wallet.form.photoIntro": "拍下卡片正面和背面。照片里的条形码会在手机上直接识别。",
    "wallet.form.front": "正面",
    "wallet.form.back": "背面",
    "wallet.form.aiRead": "用 AI 读取卡名和卡号",
    "wallet.form.aiNeedsPhoto": "先添加一张卡片照片。",
    "wallet.form.name": "卡片名称",
    "wallet.form.namePlaceholder": "例如：Albert Heijn 会员卡",
    "wallet.form.nameRequired": "请填写卡片名称。",
    "wallet.form.wallet": "卡包",
    "wallet.form.country": "国家",
    "wallet.form.countryPlaceholder": "例如：Nederland",
    "wallet.form.number": "卡号",
    "wallet.form.numberHint": "卡片上印的号码。",
    "wallet.form.barcode": "条码内容",
    "wallet.form.barcodeHint": "通常由照片自动识别，也可以手动输入。",
    "wallet.form.format": "条码类型",
    "wallet.form.formatAuto": "自动",
    "wallet.form.notes": "备注",
    "wallet.form.codePreview": "识别出的条形码",
    "wallet.form.advanced": "高级",
    "wallet.form.advancedSub": "国家、条码内容、条码类型、备注",

    "wallet.scan.looking": "正在照片里找条形码…",
    "wallet.scan.none": "这张照片里没找到条形码。可以换一张更清晰的，或在下面手动输入卡号。",
    "wallet.scan.found": "找到 {format} 条形码，已填入下方。",
    "wallet.scan.several": "照片里有好几个条码，用的是第一个，请核对。",

    "wallet.error.exists": "这张卡已经在你的卡包里了。",
    "wallet.error.needCode": "请填写卡号或条码，或者添加一张卡片照片。",
    "wallet.error.invalidWallet": "这个卡包已经不存在了，请选择另一个。",
    "wallet.error.notEmpty": "卡包里还有卡片。请先把卡片移走再删除。",
  },
  en: {
    "wallet.scan.needNumber": "Enter the card number, or photograph the barcode again",
    "wallet.import.open": "Import from another wallet",
    "wallet.import.title": "Import from another wallet",
    "wallet.import.intro": "Cards already in Apple Wallet, Google Wallet, Klarna (Stocard) or another app? Pick a way and bring them all over at once. Everything is read on your phone, and you check the list before saving.",
    "wallet.import.apple": "Apple Wallet",
    "wallet.import.apple1": "In Wallet, open a card and tap “…” at the top right.",
    "wallet.import.apple2": "Choose “Share Pass”, then “Save to Files” (if it isn't there, mail it to yourself and save the attachment to Files). Once per card.",
    "wallet.import.apple3": "Come back, tap the button below and pick all the cards (.pkpass files) at once. Some cards can't be shared: use “Screenshots” below for those.",
    "wallet.import.pickPass": "Choose Apple Wallet cards (.pkpass)",
    "wallet.import.shots": "Screenshots (Google Wallet, Klarna/Stocard, any app)",
    "wallet.import.shots1": "In the old app, open the cards one by one so the barcode shows in full and clearly.",
    "wallet.import.shots2": "Take a screenshot of each card (ideally with the shop's name showing).",
    "wallet.import.shots3": "Come back, tap the button below and pick all the screenshots at once.",
    "wallet.import.pickShots": "Choose screenshots (several at once)",
    "wallet.import.file": "Export file (Catima and others)",
    "wallet.import.fileHint": "Some wallet apps can “export/back up” to a .csv or .zip file (for example Catima on Android). Export without a password, then choose that file here.",
    "wallet.import.pickFile": "Choose export file (.csv / .zip)",
    "wallet.import.reading": "Reading {done} / {total}…",
    "wallet.import.none": "No cards found. For screenshots, make the barcode complete and sharp; for files, make sure there's no password.",
    "wallet.import.check": "Check the list: names can be changed, untick what you don't want. Greyed out: already in your wallet.",
    "wallet.import.failed": "{n} files or screenshots couldn't be read (barcode cut off, blurry, or not a card).",
    "wallet.import.namePh": "Shop name",
    "wallet.import.have": "already there",
    "wallet.import.needName": "{n} cards still need a shop name.",
    "wallet.import.more": "Start again another way",
    "wallet.import.save": "Save {n} cards",
    "wallet.import.done": "{n} cards imported.",
    "wallet.import.skipped": "{n} were already there and were skipped.",
    "wallet.scan.maybe": "By its colours it may be one of these — tap it:",
    "wallet.scan.pickFile": "Choose from photos or files",
    "wallet.scan.photoCard": "Take a photo of the card",
    "wallet.scan.processing": "Reading the card: barcode, number, shop…",
    "wallet.scan.noCodeOnPhoto": "No barcode in that photo. Take one more of the side with the barcode (usually the back).",
    "wallet.scan.photoBack": "Photo of the barcode side",
    "wallet.scan.yourCard": "Your card",
    "wallet.scan.pickShopShort": "Pick the shop",
    "wallet.scan.needShop": "Tap the shop below (or type its name) and you can save the card.",
    "wallet.scan.title": "Scan a card",
    "wallet.scan.confirmTitle": "Check the card",
    "wallet.scan.hint": "Hold the card’s barcode or QR code in the frame; it’s read automatically",
    "wallet.scan.noCamera": "The camera can’t be opened. Take a photo of the card’s barcode, or type the card number.",
    "wallet.scan.photo": "Photo of the barcode",
    "wallet.scan.manual": "No barcode? Type the number",
    "wallet.scan.noCode": "No barcode found in that photo. Try again with the code sharp and straight.",
    "wallet.scan.again": "Scan again",
    "wallet.scan.save": "Add to wallet",
    "wallet.scan.fullForm": "Fill in everything by hand (photos, country, notes…)",
    "wallet.scan.reading": "Reading the shop’s name on the card…",
    "wallet.scan.recognised": "Recognised: {name}",
    "wallet.scan.number": "Card number",
    "wallet.scan.shop": "Which shop is it for?",
    "wallet.scan.shopSearch": "Search shops, or type a name",
    "wallet.scan.otherShop": "Not listed: it will be called “{name}”",
    "wallet.scan.addCode": "Scan this card’s barcode",
    "wallet.action.notes": "Notes",
    "wallet.action.photos": "Card photos",
    "wallet.action.share": "Share card",
    "wallet.brandPick": "Pick the shop for its logo and colours",
    "wallet.form.colorAuto": "Auto",
    "wallet.form.color": "Card colour",
    "wallet.frequent": "Most used · sorted by how you use them",
    "wallet.groupsHint": "Groups just help you sort cards. Empty groups don't show on the wallet page.",
    "wallet.manageGroups": "Groups",
    "wallet.all": "All",
    "wallet.groups": "Groups",
    "wallet.add": "Add",
    "wallet.title": "Loyalty cards",
    "wallet.hero": "All your cards, one tap away",
    "wallet.heroSub": "Open a card at the till and let the cashier scan the barcode from your screen.",
    "wallet.search": "Find a card",
    "wallet.addCard": "Add card",
    "wallet.newWallet": "New wallet",
    "wallet.results": "Results · {n}",
    "wallet.noMatches": "No cards match your search.",
    "wallet.empty.title": "No cards yet",
    "wallet.empty.body": "Take a photo of a card's barcode. Your phone reads the code right away, so you can show it at checkout and leave the plastic at home.",
    "wallet.noWallet": "Not in a wallet",
    "wallet.unnamed": "Wallet",
    "wallet.preset.everyday": "Groceries & everyday",
    "wallet.preset.dining": "Dining & coffee",
    "wallet.preset.shopping": "Shopping & gifts",
    "wallet.preset.travel": "Travel & leisure",
    "wallet.addHere": "Add a card here",
    "wallet.cardAdded": "Card added",

    "wallet.folder.edit": "Edit wallet {name}",
    "wallet.folder.empty": "This wallet is empty.",
    "wallet.folder.newTitle": "New wallet",
    "wallet.folder.renameTitle": "Wallet name",
    "wallet.folder.name": "Name",
    "wallet.folder.namePlaceholder": "e.g. Pharmacy",
    "wallet.folder.create": "Create",
    "wallet.folder.created": "Wallet created",
    "wallet.folder.delete": "Delete wallet",
    "wallet.folder.deleted": "Wallet deleted",
    "wallet.folder.deleteHint": "Only empty wallets can be deleted. Move its cards to another wallet first.",

    "wallet.trash.title": "Card trash · {n}",
    "wallet.trash.sub": "Restore cards or delete them for good",
    "wallet.trash.heading": "Card trash",
    "wallet.trash.empty": "The trash is empty.",
    "wallet.trash.when": "Moved to trash {date}",
    "wallet.trash.foreverBody": "Delete “{name}” and its photos for good? This can't be undone.",

    "wallet.showAtCheckout": "Show at checkout",
    "wallet.brightness": "Turn your screen brightness up so it scans easily.",
    "wallet.noCode": "No barcode saved for this card. Show the number or the photo instead.",
    "wallet.copyNumber": "Copy card number",
    "wallet.copied": "Card number copied",
    "wallet.copyFailed": "Couldn't copy. Select the number by hand.",
    "wallet.codeDetails": "Barcode contents",
    "wallet.viewPhoto": "View {side} full size",
    "wallet.barcodeAlt": "Barcode: {value}",
    "wallet.barcodeFailed": "This barcode can't be drawn. Show the number or the photo instead.",
    "wallet.editMove": "Edit / move",
    "wallet.moveToTrash": "Move to trash",

    "wallet.form.addTitle": "Add card",
    "wallet.form.editTitle": "Edit card",
    "wallet.form.photoIntro": "Take a photo of the front and back. Barcodes in the photos are read on your phone.",
    "wallet.form.front": "Front",
    "wallet.form.back": "Back",
    "wallet.form.aiRead": "Read the card name with AI",
    "wallet.form.aiNeedsPhoto": "Add a photo of the card first.",
    "wallet.form.name": "Card name",
    "wallet.form.namePlaceholder": "e.g. Albert Heijn Bonuskaart",
    "wallet.form.nameRequired": "Please enter the card name.",
    "wallet.form.wallet": "Wallet",
    "wallet.form.country": "Country",
    "wallet.form.countryPlaceholder": "e.g. Nederland",
    "wallet.form.number": "Card number",
    "wallet.form.numberHint": "The number printed on the card.",
    "wallet.form.barcode": "Barcode",
    "wallet.form.barcodeHint": "Usually read from the photo. You can also type it.",
    "wallet.form.format": "Barcode type",
    "wallet.form.formatAuto": "Automatic",
    "wallet.form.notes": "Notes",
    "wallet.form.codePreview": "Detected barcode",
    "wallet.form.advanced": "Advanced",
    "wallet.form.advancedSub": "Country, barcode text, barcode type, notes",

    "wallet.scan.looking": "Looking for a barcode…",
    "wallet.scan.none": "No barcode found in this photo. Try a sharper one, or type the card number below.",
    "wallet.scan.found": "Found a {format} barcode and filled it in below.",
    "wallet.scan.several": "There are several codes in the photo; we used the first one, so please check it.",

    "wallet.error.exists": "This card is already in your wallet.",
    "wallet.error.needCode": "Add a card number, a barcode or a photo of the card.",
    "wallet.error.invalidWallet": "That wallet no longer exists. Please choose another one.",
    "wallet.error.notEmpty": "This wallet still has cards in it. Move them out before deleting it.",
  },
  nl: {
    "wallet.scan.needNumber": "Vul het kaartnummer in, of maak opnieuw een foto van de streepjescode",
    "wallet.import.open": "Importeren uit andere app",
    "wallet.import.title": "Importeren uit andere app",
    "wallet.import.intro": "Kaarten al in Apple Wallet, Google Wallet, Klarna (Stocard) of een andere app? Kies een manier en haal ze in één keer over. Alles wordt op je telefoon gelezen en je controleert de lijst voor het opslaan.",
    "wallet.import.apple": "Apple Wallet",
    "wallet.import.apple1": "Open in Wallet een kaart en tik rechtsboven op „…”.",
    "wallet.import.apple2": "Kies „Deel pas” en dan „Bewaar in Bestanden” (staat dat er niet bij, mail hem naar jezelf en bewaar de bijlage in Bestanden). Eén keer per kaart.",
    "wallet.import.apple3": "Kom terug, tik op de knop hieronder en kies alle kaarten (.pkpass-bestanden) tegelijk. Sommige kaarten kun je niet delen: gebruik daarvoor „Schermafbeeldingen”.",
    "wallet.import.pickPass": "Apple Wallet-kaarten kiezen (.pkpass)",
    "wallet.import.shots": "Schermafbeeldingen (Google Wallet, Klarna/Stocard, elke app)",
    "wallet.import.shots1": "Open in de oude app de kaarten één voor één, zodat de barcode helemaal en duidelijk te zien is.",
    "wallet.import.shots2": "Maak van elke kaart een schermafbeelding (liefst met de naam van de winkel erop).",
    "wallet.import.shots3": "Kom terug, tik op de knop hieronder en kies alle schermafbeeldingen tegelijk.",
    "wallet.import.pickShots": "Schermafbeeldingen kiezen (meerdere tegelijk)",
    "wallet.import.file": "Exportbestand (Catima en andere)",
    "wallet.import.fileHint": "Sommige apps kunnen „exporteren/back-uppen” naar een .csv- of .zip-bestand (bijv. Catima op Android). Exporteer zonder wachtwoord en kies dat bestand hier.",
    "wallet.import.pickFile": "Exportbestand kiezen (.csv / .zip)",
    "wallet.import.reading": "Bezig met lezen {done} / {total}…",
    "wallet.import.none": "Geen kaarten gevonden. Zorg bij schermafbeeldingen voor een complete, scherpe barcode; bij bestanden dat er geen wachtwoord op zit.",
    "wallet.import.check": "Controleer de lijst: namen kun je wijzigen, vink uit wat je niet wilt. Grijs: staat al in je kaartenmapje.",
    "wallet.import.failed": "{n} bestanden of schermafbeeldingen konden niet gelezen worden (barcode afgesneden, wazig of geen kaart).",
    "wallet.import.namePh": "Naam van de winkel",
    "wallet.import.have": "staat er al",
    "wallet.import.needName": "{n} kaarten hebben nog geen winkelnaam.",
    "wallet.import.more": "Opnieuw op een andere manier",
    "wallet.import.save": "{n} kaarten opslaan",
    "wallet.import.done": "{n} kaarten geïmporteerd.",
    "wallet.import.skipped": "{n} stonden er al en zijn overgeslagen.",
    "wallet.scan.maybe": "Op kleur is het misschien een van deze — tik erop:",
    "wallet.scan.pickFile": "Kies uit foto’s of bestanden",
    "wallet.scan.photoCard": "Maak een foto van de kaart",
    "wallet.scan.processing": "Kaart lezen: code, nummer, winkel…",
    "wallet.scan.noCodeOnPhoto": "Geen streepjescode op die foto. Maak er nog een van de kant met de code (meestal de achterkant).",
    "wallet.scan.photoBack": "Foto van de kant met de code",
    "wallet.scan.yourCard": "Je kaart",
    "wallet.scan.pickShopShort": "Kies de winkel",
    "wallet.scan.needShop": "Tik hieronder op de winkel (of typ de naam) en je kunt de kaart bewaren.",
    "wallet.scan.title": "Kaart scannen",
    "wallet.scan.confirmTitle": "Kaart controleren",
    "wallet.scan.hint": "Houd de streepjes- of QR-code van de kaart in het kader; hij wordt vanzelf gelezen",
    "wallet.scan.noCamera": "De camera kan niet openen. Maak een foto van de streepjescode of typ het kaartnummer.",
    "wallet.scan.photo": "Foto van de code",
    "wallet.scan.manual": "Geen code? Typ het nummer",
    "wallet.scan.noCode": "Geen code gevonden op de foto. Probeer opnieuw, scherp en recht.",
    "wallet.scan.again": "Opnieuw scannen",
    "wallet.scan.save": "In de kaartenmap",
    "wallet.scan.fullForm": "Alles zelf invullen (foto’s, land, notities…)",
    "wallet.scan.reading": "De winkelnaam op de kaart lezen…",
    "wallet.scan.recognised": "Herkend: {name}",
    "wallet.scan.number": "Kaartnummer",
    "wallet.scan.shop": "Van welke winkel is de kaart?",
    "wallet.scan.shopSearch": "Zoek een winkel of typ een naam",
    "wallet.scan.otherShop": "Niet in de lijst: hij heet dan “{name}”",
    "wallet.scan.addCode": "Streepjescode van deze kaart scannen",
    "wallet.action.notes": "Notities",
    "wallet.action.photos": "Kaartfoto’s",
    "wallet.action.share": "Kaart delen",
    "wallet.brandPick": "Kies de winkel voor logo en kleuren",
    "wallet.form.colorAuto": "Automatisch",
    "wallet.form.color": "Kleur van de kaart",
    "wallet.frequent": "Vaak gebruikt · op volgorde van gebruik",
    "wallet.groupsHint": "Groepen helpen je kaarten te ordenen. Lege groepen zie je niet op de kaartenpagina.",
    "wallet.manageGroups": "Groepen",
    "wallet.all": "Alle",
    "wallet.groups": "Groepen",
    "wallet.add": "Toevoegen",
    "wallet.title": "Klantenkaarten",
    "wallet.hero": "Al je pasjes bij de hand",
    "wallet.heroSub": "Open een kaart bij de kassa en laat de streepjescode van je scherm scannen.",
    "wallet.search": "Kaart zoeken",
    "wallet.addCard": "Kaart toevoegen",
    "wallet.newWallet": "Nieuw mapje",
    "wallet.results": "Resultaten · {n}",
    "wallet.noMatches": "Geen kaarten gevonden.",
    "wallet.empty.title": "Nog geen kaarten",
    "wallet.empty.body": "Maak een foto van de streepjescode op je pasje. Je telefoon leest de code meteen, zodat je hem bij de kassa kunt laten zien en het pasje thuis kan blijven.",
    "wallet.noWallet": "Niet in een mapje",
    "wallet.unnamed": "Mapje",
    "wallet.preset.everyday": "Boodschappen & dagelijks",
    "wallet.preset.dining": "Eten & koffie",
    "wallet.preset.shopping": "Winkelen & cadeaus",
    "wallet.preset.travel": "Reizen & vrije tijd",
    "wallet.addHere": "Kaart hier toevoegen",
    "wallet.cardAdded": "Kaart toegevoegd",

    "wallet.folder.edit": "Mapje {name} bewerken",
    "wallet.folder.empty": "Dit mapje is leeg.",
    "wallet.folder.newTitle": "Nieuw mapje",
    "wallet.folder.renameTitle": "Naam van het mapje",
    "wallet.folder.name": "Naam",
    "wallet.folder.namePlaceholder": "bijv. Drogist",
    "wallet.folder.create": "Aanmaken",
    "wallet.folder.created": "Mapje aangemaakt",
    "wallet.folder.delete": "Mapje verwijderen",
    "wallet.folder.deleted": "Mapje verwijderd",
    "wallet.folder.deleteHint": "Je kunt alleen een leeg mapje verwijderen. Verplaats de kaarten eerst naar een ander mapje.",

    "wallet.trash.title": "Prullenbak voor kaarten · {n}",
    "wallet.trash.sub": "Zet kaarten terug of verwijder ze definitief",
    "wallet.trash.heading": "Prullenbak voor kaarten",
    "wallet.trash.empty": "De prullenbak is leeg.",
    "wallet.trash.when": "Naar prullenbak op {date}",
    "wallet.trash.foreverBody": "‘{name}’ en de foto's definitief verwijderen? Dit kun je niet ongedaan maken.",

    "wallet.showAtCheckout": "Laten zien bij de kassa",
    "wallet.brightness": "Zet je scherm wat feller, dan scant het makkelijker.",
    "wallet.noCode": "Voor deze kaart is geen streepjescode opgeslagen. Laat het nummer of de foto zien.",
    "wallet.copyNumber": "Kaartnummer kopiëren",
    "wallet.copied": "Kaartnummer gekopieerd",
    "wallet.copyFailed": "Kopiëren lukte niet. Selecteer het nummer zelf.",
    "wallet.codeDetails": "Inhoud van de code",
    "wallet.viewPhoto": "{side} groot bekijken",
    "wallet.barcodeAlt": "Streepjescode: {value}",
    "wallet.barcodeFailed": "Deze code kan niet worden getekend. Laat het nummer of de foto zien.",
    "wallet.editMove": "Bewerken / verplaatsen",
    "wallet.moveToTrash": "Naar prullenbak",

    "wallet.form.addTitle": "Kaart toevoegen",
    "wallet.form.editTitle": "Kaart bewerken",
    "wallet.form.photoIntro": "Maak een foto van de voor- en achterkant. Streepjescodes op de foto's worden op je telefoon gelezen.",
    "wallet.form.front": "Voorkant",
    "wallet.form.back": "Achterkant",
    "wallet.form.aiRead": "Kaartnaam lezen met AI",
    "wallet.form.aiNeedsPhoto": "Voeg eerst een foto van de kaart toe.",
    "wallet.form.name": "Naam van de kaart",
    "wallet.form.namePlaceholder": "bijv. Albert Heijn Bonuskaart",
    "wallet.form.nameRequired": "Vul de naam van de kaart in.",
    "wallet.form.wallet": "Mapje",
    "wallet.form.country": "Land",
    "wallet.form.countryPlaceholder": "bijv. Nederland",
    "wallet.form.number": "Kaartnummer",
    "wallet.form.numberHint": "Het nummer dat op de kaart staat.",
    "wallet.form.barcode": "Streepjescode",
    "wallet.form.barcodeHint": "Meestal gelezen van de foto. Je kunt hem ook intypen.",
    "wallet.form.format": "Soort code",
    "wallet.form.formatAuto": "Automatisch",
    "wallet.form.notes": "Notities",
    "wallet.form.codePreview": "Herkende streepjescode",
    "wallet.form.advanced": "Geavanceerd",
    "wallet.form.advancedSub": "Land, inhoud en soort streepjescode, notities",

    "wallet.scan.looking": "Streepjescode zoeken…",
    "wallet.scan.none": "Geen streepjescode gevonden op deze foto. Probeer een scherpere foto of typ het kaartnummer hieronder.",
    "wallet.scan.found": "{format}-code gevonden en hieronder ingevuld.",
    "wallet.scan.several": "Er staan meerdere codes op de foto; we hebben de eerste gebruikt, controleer hem even.",

    "wallet.error.exists": "Deze kaart staat al in je portemonnee.",
    "wallet.error.needCode": "Vul een kaartnummer of streepjescode in, of voeg een foto van de kaart toe.",
    "wallet.error.invalidWallet": "Dat mapje bestaat niet meer. Kies een ander mapje.",
    "wallet.error.notEmpty": "Er zitten nog kaarten in dit mapje. Verplaats ze eerst voordat je het verwijdert.",
  },
} satisfies Dict;
